import { ApolloProvider, useQuery } from "@apollo/client";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import { useEffect } from "react";

import { UserQuery } from "../../__generated__/UserQuery";
import { webTheme } from "../../constants";
import { AnalyticsContext, AnalyticsService } from "../../lib/analytics";
import { GraphQlClient, USER_QUERY } from "../../lib/graphql";
import { useAuthenticatedQueryOptions } from "../../lib/graphql/hooks";
import { AuthContext, AuthService } from "../Auth";

const authService = new AuthService();
const analyticsService = new AnalyticsService();
export const graphqlClient = new GraphQlClient({ authService });

export interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <GraphQlProvider>
      <OtherProviders>{children}</OtherProviders>
    </GraphQlProvider>
  );
};

const GraphQlProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ApolloProvider client={graphqlClient.getApolloClient()}>
      {children}
    </ApolloProvider>
  );
};

const OtherProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <ThemeProvider theme={webTheme}>
      <AuthContext.Provider value={authService}>
        <AnalyticsContext.Provider value={analyticsService}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <UserQueryWrapper>{children}</UserQueryWrapper>
          </MuiPickersUtilsProvider>
        </AnalyticsContext.Provider>
      </AuthContext.Provider>
    </ThemeProvider>
  );
};

const UserQueryWrapper = ({ children }: { children: React.ReactNode }) => {
  const { skip } = useAuthenticatedQueryOptions();
  const userQuery = useQuery<UserQuery>(USER_QUERY, { skip });

  useEffect(() => {
    analyticsService.setUserId(userQuery.data?.user?.id || null);
  }, [userQuery]);

  return <>{children}</>;
};
